module.exports = __webpack_public_path__ + "img/tema-3-24.4c370b8d.png";